export class Environment {
  static getEnvString(name) {
    const variable = process.env[name];

    if (!variable) {
      console.error(`[Environment] Missing ${name} environment variable`);
      return;
    }

    return variable;
  }

  static getEnvNumber(name) {
    const variable = process.env[name];

    if (!variable) {
      console.error(`[Environment] Missing ${name} environment variable`);
      return;
    }

    const convertedNumber = Number(variable);

    if (Number.isNaN(convertedNumber)) {
      console.error(
        `[Environment] Value ${variable} of variable ${name} is not valid as a number`
      );
      return;
    }

    return convertedNumber;
  }

  static getEnvBoolean(name) {
    const variable = process.env[name];

    if (!variable) {
      console.error(`[Environment] Missing ${name} environment variable`);
      return;
    }

    if (variable !== "true" && variable !== "false") {
      console.error(
        `[Environment] Value ${variable} of variable ${name} is not valid as a boolean`
      );
      return;
    }

    return variable === "true";
  }
}
